import { Typography } from '@mui/material';
import InfoButton from '../InfoButton';

const FieldLabel = ({ children, infoMessage }) => (
	<Typography
		variant="h6"
		fontWeight={600}
		sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}
	>
		{children}
		{infoMessage && (
			<InfoButton
				message={infoMessage}
				size="small"
				iconSize="small"
				customIconStyles={{ padding: 0.25 }}
			/>
		)}
	</Typography>
);

export default FieldLabel;
